import { useEffect } from 'react';

const useScrollToElement = (
  elementId: string,
  containerRef: React.RefObject<HTMLElement>,
  onElementFound: (el: HTMLElement) => void
) => {
  useEffect(() => {
    if (!elementId) return;

    let attempts = 0;
    const maxAttempts = 5;

    const tryScrollToElement = () => {
      const container = containerRef.current;
      if (!container) return;
      const el = document.getElementById(elementId);
      if (el) {
        try {
          const containerRect = container.getBoundingClientRect();
          const elRect = el.getBoundingClientRect();
          const deltaTop = elRect.top - containerRect.top;
          const centeredTop =
            container.scrollTop +
            deltaTop -
            (container.clientHeight / 2 - el.clientHeight / 2);
          const targetTop = Math.max(0, centeredTop);
          container.scrollTo({ top: targetTop, behavior: 'smooth' });

          if (onElementFound) {
            onElementFound(el);
          }
        } catch (e) {
          console.log('Error scrolling to element: ', e);
        }
        return;
      }

      attempts += 1;
      if (attempts < maxAttempts) {
        setTimeout(tryScrollToElement, 150);
      }
    };

    // defer until after initial render to ensure DOM exists
    setTimeout(tryScrollToElement, 0);
  }, [elementId, containerRef, onElementFound]);
};

export default useScrollToElement;